import { render, staticRenderFns } from "./HomeworkList.vue?vue&type=template&id=d3ff5310&"
import script from "./HomeworkList.vue?vue&type=script&lang=js&"
export * from "./HomeworkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports